import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-mcommerce-trip-detail',
  templateUrl: './mcommerce-trip-detail.component.html',
  styleUrls: ['./mcommerce-trip-detail.component.scss']
})
export class McommerceTripDetailComponent implements OnInit {

  tripId;
  cart;

  constructor(private route: ActivatedRoute) {
    this.tripId = this.route.snapshot.params.tripid;
    this.cart = [
      { thumbnail: 'https://bit.ly/2nJOECC', description: 'Zumo de naranja natural 1L', trademark: 'Zumosol', ean: '9002236311036', time: '16:04', quantity: '2', unitPrice: '1,02', subtotalPrice: '2,04' },
      { thumbnail: 'https://bit.ly/2nJOECC', description: 'Zumo de naranja natural 1L', trademark: 'Zumosol', ean: '9002236311036', time: '16:04', quantity: '2', unitPrice: '1,02', subtotalPrice: '2,04' },
      { thumbnail: 'https://bit.ly/2nJOECC', description: 'Zumo de naranja natural 1L', trademark: 'Zumosol', ean: '9002236311036', time: '16:04', quantity: '2', unitPrice: '1,02', subtotalPrice: '2,04' },
      { thumbnail: 'https://bit.ly/2nJOECC', description: 'Zumo de naranja natural 1L', trademark: 'Zumosol', ean: '9002236311036', time: '16:04', quantity: '2', unitPrice: '1,02', subtotalPrice: '2,04' },
      { thumbnail: 'https://bit.ly/2nJOECC', description: 'Zumo de naranja natural 1L', trademark: 'Zumosol', ean: '9002236311036', time: '16:04', quantity: '2', unitPrice: '1,02', subtotalPrice: '2,04' },
      { thumbnail: 'https://bit.ly/2nJOECC', description: 'Zumo de naranja natural 1L', trademark: 'Zumosol', ean: '9002236311036', time: '16:04', quantity: '2', unitPrice: '1,02', subtotalPrice: '2,04' }
     ];
  }

  ngOnInit() {
  }

}
